export default {
  name: "cwid",
  in: "header",
  required: false,
  description:
    "Cross Web ID - another visitor identifier that allows the system to provide information about that visitor. CWID assumes login to SizeId system - one of identifier must be filled",
  schema: {
    type: "string",
    example: "11990"
  }
};
